export default __webpack_public_path__ + "images/LUEBECK.0fefd2d.png";